// Open header menus on hover for desktop (keeps click/tap on mobile)
(() => {
  const isDesktop = () => window.matchMedia('(min-width: 990px)').matches;

  // Dawn marks these as <details is="details-disclosure"> in the header
  const menus = document.querySelectorAll('header details[is="details-disclosure"], header details.menu-opening');

  if (!menus.length) return;

  menus.forEach((det) => {
    const summary = det.querySelector('summary');
    if (!summary) return;

    // Hover open/close
    det.addEventListener('mouseenter', () => {
      if (isDesktop()) {
        det.setAttribute('open', '');
        summary.setAttribute('aria-expanded', 'true');
      }
    });

    det.addEventListener('mouseleave', () => {
      if (isDesktop()) {
        det.removeAttribute('open');
        summary.setAttribute('aria-expanded', 'false');
      }
    });

    // Prevent accidental navigation on desktop’s first click (optional)
    // First click opens; second click (within same focus) follows link
    let armedForNavigate = false;
    summary.addEventListener('click', (e) => {
      if (!isDesktop()) return; // keep normal behavior on mobile
      if (!det.hasAttribute('open')) {
        e.preventDefault();
        det.setAttribute('open', '');
        summary.setAttribute('aria-expanded', 'true');
        armedForNavigate = true;
      } else if (armedForNavigate) {
        // allow navigation on second click
        armedForNavigate = false;
      } else {
        e.preventDefault();
      }
    });
  });
})();
